import React from 'react';
import classNames from 'classnames';

import { CourseActionButton } from '../../ActionButton';

import styles from './CourseHeaderNavigation.module.scss';

function CourseHeaderNavigation({
  isFreeCourse,
  courseTypeId,
  haveDemoVideos,
  haveValidity,
  haveExams,
  haveFaqs,
  currentSection,
  onItemClick,
  isSticky,
  havePdf,
  userDetails,
  handleBuyNow,
  goToMyCourse,
  handleEmiRepayment,
}) {
  const menuItems = React.useMemo(
    () =>
      [
        {
          title: 'Description',
          slug: 'course-details',
          isEnabled: courseTypeId === 6,
        },
        {
          title: 'View PDF',
          slug: 'course-plan-pdf',
          isEnabled: havePdf,
        },
        {
          title: 'Exams Covered',
          slug: 'exams-covered',
          isEnabled: haveExams,
        },
        {
          title: 'About Authors',
          slug: 'about-authors',
          isEnabled: true,
        },
        {
          title: 'Demo Videos',
          slug: 'demo-videos',
          isEnabled: !isFreeCourse && !haveValidity && haveDemoVideos,
        },
        {
          title: 'Course Content',
          slug: 'course-content',
          isEnabled: courseTypeId !== 5,
        },
        {
          title: 'FAQs',
          slug: 'faqs',
          isEnabled: haveFaqs,
        },
        {
          title: 'Pricing',
          slug: 'pricing',
          isEnabled: !isSticky && !haveValidity,
        },
        {
          render: () => (
            <CourseActionButton
              className={styles.courseAction}
              userDetails={userDetails}
              onClick={handleBuyNow}
              goToMyCourse={goToMyCourse}
              handleEmiRepayment={handleEmiRepayment}
            />
          ),
          slug: 'buy-now',
          isEnabled: isSticky,
        },
      ].filter((menuItem) => menuItem.isEnabled),
    [
      courseTypeId, handleBuyNow, haveDemoVideos, haveExams,
      haveFaqs, havePdf, haveValidity, isFreeCourse, isSticky,
      userDetails,
    ],
  );

  return (
    <nav className={classNames(styles.navigation, { [styles.isSticky]: isSticky })}>
      <ul className={styles.navigationList}>
        {menuItems.map((menuItem) => (
          <li
            key={menuItem.slug}
            className={classNames(styles.navigationItem, { [styles.isActive]: menuItem.slug === currentSection })}
          >
            {typeof menuItem.render !== 'undefined' ? (
              menuItem.render()
            ) : (
              <button type="button" onClick={onItemClick(menuItem.slug)}>
                {menuItem.title}
              </button>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default CourseHeaderNavigation;
